<div class="content">

    <span class="mat-title">Relatório</span>

    <mat-tab-group (selectedTabChange)="onSelectTab($event)" [disablePagination]="submiting">
        <mat-tab label="Filtro simples">

            <div class="controls">
                <form [formGroup]="form" style="width: 100%;">

                    <div class="row">

                        <mat-form-field appearance="outline">
                            <mat-label>Atributo para pesquisa</mat-label>
                            <mat-select formControlName="field" [disabled]="submiting">
                                <mat-optgroup label="Informações básicas">
                                    <mat-option value="gender">Sexo</mat-option>
                                    <mat-option value="state">Estado</mat-option>
                                </mat-optgroup>
                                <mat-optgroup label="Escolaridade">
                                    <mat-option value="education">Nível de escolaridade</mat-option>
                                </mat-optgroup>
                                <mat-optgroup label="Cargo">
                                    <mat-option value="desired_job_title">Cargo Desejado</mat-option>
                                </mat-optgroup>
                                <mat-optgroup label="Profissional">
                                    <mat-option value="professional:professionalName">Setor
                                        (professional_name)</mat-option>
                                    <mat-option value="professional:specializationName">Área
                                        (specialization_name)</mat-option>
                                    <mat-option value="professional:roleLevel">Cargo (role_level)</mat-option>
                                    <mat-option value="professional:branch">Ramo de atividade (branch)</mat-option>
                                </mat-optgroup>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Segmento para pesquisa</mat-label>
                            <mat-select [disabled]="submiting" formControlName="segment">
                                <mat-option [value]="null">Todos</mat-option>
                                <ng-container *ngFor="let segment of segments">
                                    <mat-option [value]="segment.id">{{ segment.name }}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Cargo desejado</mat-label>
                            <mat-select formControlName="desiredJob">
                                <mat-select-filter [array]="sinonimos" [displayMember]="'Name'"
                                    placeholder="Nome do cargo" noResultsMessage="Nada encontrado!"
                                    (filteredReturn)="filteredSinonimos = $event"></mat-select-filter>
                                <mat-option [value]="item" *ngFor="let item of filteredSinonimos">
                                    {{item.Name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Profissão</mat-label>
                            <input matInput type="text" formControlName="office" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Data de cadastro</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matInput matStartDate formControlName="dateStart">
                                <input matInput matEndDate formControlName="dateEnd">
                            </mat-date-range-input>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        </mat-form-field>

                        <button mat-icon-button color="accent" type="reset">
                            <mat-icon>close</mat-icon>
                        </button>

                    </div>

                </form>

                <ng-container *ngIf="filters.length > 0">

                    <p class="mat-body-2">Filtro segmentos</p>

                    <mat-chip-list>
                        <ng-container *ngFor="let filter of filters; let i = index">
                            <mat-chip color="primary" (removed)="removeFilter(i)" selected>
                                {{ getFilterLabel(filter.name) }} / {{filter.value}}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip>
                        </ng-container>
                    </mat-chip-list>

                    <div style="margin: 10px 0px;">
                        <button mat-stroked-button color="primary" (click)="openSegment()">Escolher segmentos</button>
                    </div>

                </ng-container>

            </div>

            <div class="chart-content" #lineChartWrapper>

                <mat-accordion>
                    <mat-expansion-panel hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Agrupameto
                            </mat-panel-title>
                            <mat-panel-description>
                                Agrupamento das informações dos candidatos
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="chart-item" *ngIf="charts['group']">
                            <ngx-charts-bar-horizontal [view]="[600, chartHeight]" [results]="charts['group']"
                                [gradient]="false" [xAxis]="true" [yAxis]="true" [legend]="false"
                                [showXAxisLabel]="false" [showYAxisLabel]="false" xAxisLabel="Quantidade"
                                [showDataLabel]="true" yAxisLabel="Filtro" (select)="chooseFilter($event)">
                            </ngx-charts-bar-horizontal>
                        </div>
                        <div class="empty-content" *ngIf="!charts['group']">
                            <span class="mat-body-2" *ngIf="!submiting">
                                Escolha um filtro acima para mostrar os gráficos.
                            </span>
                            <span class="mat-body-2" *ngIf="submiting">
                                Carregando...
                            </span>
                        </div>
                    </mat-expansion-panel>
                    <mat-expansion-panel hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Candidatos por data
                            </mat-panel-title>
                            <mat-panel-description>
                                Candidatos cadastrados por data
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="chart-item">
                            <ng-container *ngIf="charts['candidatesByDate']">
                                <ngx-charts-line-chart [view]="[chartWidth, chartHeight]"
                                    [results]="charts['candidatesByDate']" [gradient]="false" [xAxis]="true"
                                    [yAxis]="true" [legend]="false" [showXAxisLabel]="false" [showYAxisLabel]="false"
                                    xAxisLabel="Quantidade" [showDataLabel]="true" yAxisLabel="Data">
                                </ngx-charts-line-chart>
                            </ng-container>
                        </div>
                        <div class="empty-content" *ngIf="!charts['candidatesByDate']">
                            <span class="mat-body-2" *ngIf="!submiting">
                                Escolha um filtro acima para mostrar os gráficos.
                            </span>
                            <span class="mat-body-2" *ngIf="submiting">
                                Carregando...
                            </span>
                        </div>
                    </mat-expansion-panel>
                    <mat-expansion-panel hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Processos seletivos por data
                            </mat-panel-title>
                            <mat-panel-description>
                                Processos seletivos cadastrados por data
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="chart-item">
                            <ng-container *ngIf="charts['processListByDate']">
                                <ngx-charts-line-chart [view]="[chartWidth, chartHeight]"
                                    [results]="charts['processListByDate']" [gradient]="false" [xAxis]="true"
                                    [yAxis]="true" [legend]="false" [showXAxisLabel]="false" [showYAxisLabel]="false"
                                    xAxisLabel="Quantidade" [showDataLabel]="true" yAxisLabel="Data">
                                </ngx-charts-line-chart>
                            </ng-container>
                        </div>
                        <div class="empty-content" *ngIf="!charts['processListByDate']">
                            <span class="mat-body-2" *ngIf="!submiting">
                                Escolha um filtro acima para mostrar os gráficos.
                            </span>
                            <span class="mat-body-2" *ngIf="submiting">
                                Carregando...
                            </span>
                        </div>
                    </mat-expansion-panel>
                    <mat-expansion-panel hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Relatório de UTM's
                            </mat-panel-title>
                            <mat-panel-description>
                                UTM das campanhas por data
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <app-utms-report></app-utms-report>
                    </mat-expansion-panel>
                </mat-accordion>

            </div>

        </mat-tab>

        <mat-tab label="Filtro avançado">
            <div class="controls">
                <button mat-raised-button color="primary" (click)="openFilterDialog()" [disabled]="submiting">
                    Abrir filtro
                </button>
                <button mat-raised-button color="warn" (click)="clearFilters()"
                    [disabled]="hasFilter() === false|| submiting">
                    Limpar resultados
                </button>
                <div style="flex: 1">
                    <form [formGroup]="formDateInterval">
                        <div class="row">
                            <mat-form-field appearance="outline">
                                <mat-label>Informe o intervalo de data do cadastro</mat-label>
                                <mat-date-range-input [rangePicker]="pickerInterval">
                                    <input matStartDate formControlName="dateStart" placeholder="Data inicial">
                                    <input matEndDate formControlName="dateEnd" placeholder="Data final">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="pickerInterval"></mat-datepicker-toggle>
                                <button *ngIf="formDateInterval.valid" mat-icon-button matSuffix color="accent"
                                    type="button" (click)="resetFormDateInterval()">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <mat-date-range-picker #pickerInterval></mat-date-range-picker>
                            </mat-form-field>
                        </div>
                    </form>
                </div>
                <div style="flex: 3">

                </div>
                <button mat-stroked-button color="primary" (click)="exportData()"
                    [disabled]="submiting || submitingTable || totalCandidates == 0">
                    <ng-container *ngIf="submitingTable">
                        <mat-icon>
                            <mat-progress-spinner mode="indeterminate" [diameter]="20"></mat-progress-spinner>
                        </mat-icon>
                    </ng-container>
                    <ng-container *ngIf="!submitingTable">
                        <mat-icon>print</mat-icon>
                    </ng-container>
                    exportar
                </button>
            </div>

            <div class="info-total">
                <ng-container *ngIf="submiting">
                    <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
                </ng-container>
                <ng-container *ngIf="!submiting">
                    <span class="mat-display-1">
                        {{ totalCandidates }}
                    </span>
                    <p class="mat-body-2">Total</p>
                </ng-container>
            </div>
            <mat-divider></mat-divider>
            <div>
                <mat-grid-list cols="4" rowHeight="2:2" gutterSize="10px">
                    <mat-grid-tile colspan="2">
                        <ng-container *ngIf="submiting">
                            <mat-progress-spinner mode="indeterminate" [diameter]="40"></mat-progress-spinner>
                        </ng-container>
                        <ng-container *ngIf="!submiting">
                            <div class="grid-tile-wrapper">
                                <mat-card id="ageChartContainer">
                                    <mat-card-title-group>
                                        <mat-card-subtitle>Distribuição por idade</mat-card-subtitle>
                                    </mat-card-title-group>
                                    <ng-container *ngIf="advCharts['age']; else emptyAgeChart">
                                        <div class="info-chart">
                                            <div>
                                                <span class="mat-title">{{ advCharts['age'].total }}</span>
                                                <p class="mat-body-1">Agrupamentos</p>
                                            </div>
                                            <mat-divider [vertical]="true"></mat-divider>
                                            <div>
                                                <span class="mat-title">{{ advCharts['age'].undefined }}</span>
                                                <p class="mat-body-1">Não definidos</p>
                                            </div>
                                        </div>
                                        <mat-divider></mat-divider>
                                        <mat-card-content style="overflow: auto">
                                            <ngx-charts-bar-vertical [view]="advCharts['age'].view"
                                                [results]="advCharts['age'].data" [gradient]="false" [xAxis]="true"
                                                [yAxis]="true" [legend]="false" [showXAxisLabel]="true"
                                                [showYAxisLabel]="true" xAxisLabel="Idades" yAxisLabel="Quantidades">
                                            </ngx-charts-bar-vertical>
                                        </mat-card-content>
                                    </ng-container>
                                    <ng-template #emptyAgeChart>
                                        <div class="empty-content">
                                            <p class="mat-body-2">
                                                Use o filtro para mostrar o gráfico
                                            </p>
                                        </div>
                                    </ng-template>
                                </mat-card>
                            </div>
                        </ng-container>
                    </mat-grid-tile>
                    <mat-grid-tile colspan="2">
                        <ng-container *ngIf="submiting">
                            <mat-progress-spinner mode="indeterminate" [diameter]="40"></mat-progress-spinner>
                        </ng-container>
                        <ng-container *ngIf="!submiting">
                            <div class="grid-tile-wrapper">
                                <mat-card id="genderChartContainer">
                                    <mat-card-title-group>
                                        <mat-card-subtitle>Distribuição por sexo</mat-card-subtitle>
                                    </mat-card-title-group>
                                    <ng-container *ngIf="advCharts['gender']; else emptyGenderChart">
                                        <div class="info-chart">
                                            <div>
                                                <span class="mat-title">{{ advCharts['gender'].total }}</span>
                                                <p class="mat-body-1">Agrupamentos</p>
                                            </div>
                                            <mat-divider [vertical]="true"></mat-divider>
                                            <div>
                                                <span class="mat-title">{{ advCharts['gender'].undefined }}</span>
                                                <p class="mat-body-1">Não definidos</p>
                                            </div>
                                        </div>
                                        <mat-divider></mat-divider>
                                        <mat-card-content>
                                            <ngx-charts-pie-chart [view]="advCharts['gender'].view"
                                                [results]="advCharts['gender'].data" [gradient]="false" [legend]="true"
                                                legendTitle="Legenda" [labels]="false" [doughnut]="false">
                                            </ngx-charts-pie-chart>
                                        </mat-card-content>
                                    </ng-container>
                                    <ng-template #emptyGenderChart>
                                        <div class="empty-content">
                                            <p class="mat-body-2">
                                                Use o filtro para mostrar o gráfico
                                            </p>
                                        </div>
                                    </ng-template>
                                </mat-card>
                            </div>
                        </ng-container>

                    </mat-grid-tile>
                    <mat-grid-tile [colspan]="2" [rowspan]="2">

                        <ng-container *ngIf="submiting">
                            <mat-progress-spinner mode="indeterminate" [diameter]="40"></mat-progress-spinner>
                        </ng-container>
                        <ng-container *ngIf="!submiting">
                            <div class="grid-tile-wrapper">
                                <mat-card id="stateChartContainer">
                                    <mat-card-title-group>
                                        <mat-card-subtitle>Distribuição por estado</mat-card-subtitle>
                                    </mat-card-title-group>
                                    <ng-container *ngIf="advCharts['state']; else emptyStateChart">
                                        <div class="info-chart">
                                            <div>
                                                <span class="mat-title">{{ advCharts['state'].total }}</span>
                                                <p class="mat-body-1">Agrupamentos</p>
                                            </div>
                                            <mat-divider [vertical]="true"></mat-divider>
                                            <div>
                                                <span class="mat-title">{{ advCharts['state'].undefined }}</span>
                                                <p class="mat-body-1">Não definidos</p>
                                            </div>
                                        </div>
                                        <mat-divider></mat-divider>
                                        <mat-card-content style="overflow: auto; aspect-ratio:  4/3;">
                                            <ngx-charts-bar-horizontal [view]="advCharts['state'].view"
                                                [results]="advCharts['state'].data" [gradient]="false" [xAxis]="true"
                                                [yAxis]="true" [legend]="false" [showXAxisLabel]="true"
                                                [showYAxisLabel]="true" xAxisLabel="Estados" yAxisLabel="Quantidades">
                                            </ngx-charts-bar-horizontal>
                                        </mat-card-content>
                                    </ng-container>
                                    <ng-template #emptyStateChart>
                                        <div class="empty-content">
                                            <p class="mat-body-2">
                                                Use o filtro para mostrar o gráfico
                                            </p>
                                        </div>
                                    </ng-template>
                                </mat-card>
                            </div>
                        </ng-container>

                    </mat-grid-tile>
                    <mat-grid-tile [colspan]="2" [rowspan]="2">
                        <ng-container *ngIf="submiting">
                            <mat-progress-spinner mode="indeterminate" [diameter]="40"></mat-progress-spinner>
                        </ng-container>
                        <ng-container *ngIf="!submiting">
                            <div class="grid-tile-wrapper">
                                <mat-card id="sinonimoChartContainer">
                                    <mat-card-title-group>
                                        <mat-card-subtitle>Distribuição por cargo</mat-card-subtitle>
                                    </mat-card-title-group>
                                    <ng-container *ngIf="advCharts['sinonimo']; else emptySinonimoChart">
                                        <div class="info-chart">
                                            <div>
                                                <span class="mat-title">{{ advCharts['sinonimo'].total }}</span>
                                                <p class="mat-body-1">Agrupamentos</p>
                                            </div>
                                            <mat-divider [vertical]="true"></mat-divider>
                                            <div>
                                                <span class="mat-title">{{ advCharts['sinonimo'].undefined }}</span>
                                                <p class="mat-body-1">Não definidos</p>
                                            </div>
                                        </div>
                                        <mat-divider></mat-divider>
                                        <mat-card-content style="overflow: auto; aspect-ratio: 4/3;">
                                            <ngx-charts-bar-horizontal [view]="advCharts['sinonimo'].view"
                                                [results]="advCharts['sinonimo'].data" [gradient]="false" [xAxis]="true"
                                                [yAxis]="true" [legend]="false" [showXAxisLabel]="true"
                                                [showYAxisLabel]="true" xAxisLabel="Cargos" yAxisLabel="Quantidades">
                                            </ngx-charts-bar-horizontal>
                                        </mat-card-content>
                                    </ng-container>
                                    <ng-template #emptySinonimoChart>
                                        <div class="empty-content">
                                            <p class="mat-body-2">
                                                Use o filtro para mostrar o gráfico
                                            </p>
                                        </div>
                                    </ng-template>
                                </mat-card>
                            </div>
                        </ng-container>
                    </mat-grid-tile>
                    <mat-grid-tile colspan="4" rowspan="2">
                        <ng-container *ngIf="submiting">
                            <mat-progress-spinner mode="indeterminate" [diameter]="40"></mat-progress-spinner>
                        </ng-container>
                        <ng-container *ngIf="!submiting">
                            <div class="grid-tile-wrapper">
                                <mat-card id="cityChartContainer">
                                    <mat-card-title-group>
                                        <mat-card-subtitle>Distribuição por cidade</mat-card-subtitle>
                                    </mat-card-title-group>
                                    <ng-container *ngIf="advCharts['city']; else emptyCityChart">
                                        <div class="info-chart">
                                            <div>
                                                <span class="mat-title">{{ advCharts['city'].total }}</span>
                                                <p class="mat-body-1">Agrupamentos</p>
                                            </div>
                                            <mat-divider [vertical]="true"></mat-divider>
                                            <div>
                                                <span class="mat-title">{{ advCharts['city'].undefined }}</span>
                                                <p class="mat-body-1">Não definidos</p>
                                            </div>
                                        </div>
                                        <mat-divider></mat-divider>
                                        <mat-card-content style="overflow: auto;aspect-ratio: 5/2">
                                            <ngx-charts-bar-vertical [view]="advCharts['city'].view"
                                                [results]="advCharts['city'].data" [gradient]="false" [xAxis]="true"
                                                [yAxis]="true" [legend]="false" [showXAxisLabel]="true"
                                                [showYAxisLabel]="true" xAxisLabel="Cidades" yAxisLabel="Quantidades">
                                            </ngx-charts-bar-vertical>
                                        </mat-card-content>
                                    </ng-container>
                                    <ng-template #emptyCityChart>
                                        <div class="empty-content">
                                            <p class="mat-body-2">
                                                Use o filtro para mostrar o gráfico
                                            </p>
                                        </div>
                                    </ng-template>
                                </mat-card>
                            </div>
                        </ng-container>
                    </mat-grid-tile>
                </mat-grid-list>
            </div>
            <mat-divider></mat-divider>
            <span class="mat-title">Registros encontrados</span>
            <ng-container *ngIf="!submitingTable">
                <table class="table" mat-table [dataSource]="dataSource">
                    <ng-container *ngFor="let attr of displayedColumns">
                        <ng-container [matColumnDef]="attr">
                            <th mat-header-cell *matHeaderCellDef>
                                <span class="th-wrapper">
                                    {{ columnsDisplayName[attr] }}
                                </span>
                            </th>
                            <td mat-cell *matCellDef="let element" (click)="openCandidateInfo(element)">
                                {{ element[attr] }}
                            </td>
                        </ng-container>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" style="cursor: pointer"></tr>
                </table>
            </ng-container>
            <ng-container *ngIf="submitingTable">
                <div class="empty-content" style="height: auto !important;">
                    <mat-progress-spinner mode="indeterminate" [diameter]="40"></mat-progress-spinner>
                </div>
            </ng-container>
            <mat-paginator [disabled]="submitingTable || dataSource.data.length == 0" [pageSizeOptions]="[20, 50, 100]"
                [length]="totalCandidates" (page)="onPageChange($event)" showFirstLastButtons></mat-paginator>

        </mat-tab>

        <mat-tab label="Outros filtros">

            <mat-accordion>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Relatório de UTM's
                        </mat-panel-title>
                        <mat-panel-description>
                            UTM das campanhas por data
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <app-utms-report></app-utms-report>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Relatório de Cargos Desejados
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <app-desired-job-title-report></app-desired-job-title-report>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Relatório de Cargo de Experiencia Profissional
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <app-sinonimo-report></app-sinonimo-report>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Relatório de Etapas de Cadastros
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <app-register-steps-report></app-register-steps-report>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Relatório de Empresas Cadastradas
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <app-companies-report></app-companies-report>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Usuários com mais de dois acessos
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <app-login-report></app-login-report>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Todos os campos preenchidos
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <app-filled-fields-report></app-filled-fields-report>
                </mat-expansion-panel>
            </mat-accordion>

        </mat-tab>
    </mat-tab-group>

</div>